export default "__VITE_ASSET__BzfU0D1___"